
import { A2AAgent } from '../types';

export const recruitingAgents: A2AAgent[] = [
  {
    id: 'recruiting-agent',
    name: 'Recruiting Agent',
    isAvailable: true,
    capabilities: ['candidate-sourcing', 'interview-coordination', 'client-matching', 'placement-tracking'],
    description: 'Handles end-to-end recruiting processes including sourcing, screening, and placements.',
    category: 'recruiting',
    version: '1.0',
    interfaces: ['a2a-messaging', 'supabase-integration'],
    maxConcurrentTasks: 5,
  },
  {
    id: 'candidate-agent',
    name: 'Candidate Agent',
    isAvailable: true,
    capabilities: ['candidate-management', 'profile-analysis', 'skill-assessment', 'availability-tracking'],
    description: 'Manages candidate profiles, tracks interactions, and analyzes qualifications.',
    category: 'recruiting',
    version: '1.0',
    interfaces: ['a2a-messaging', 'supabase-integration'],
    maxConcurrentTasks: 8,
  },
  {
    id: 'candidate-search-agent',
    name: 'Candidate Search Agent',
    isAvailable: true,
    capabilities: ['natural-language-search', 'skill-matching', 'experience-filtering', 'candidate-ranking'],
    description: 'Performs intelligent candidate searches using natural language queries and advanced matching algorithms.',
    category: 'recruiting',
    version: '1.0',
    interfaces: ['a2a-messaging', 'supabase-integration', 'ai-processing'],
    maxConcurrentTasks: 3,
  },
  {
    id: 'client-agent',
    name: 'Client Agent',
    isAvailable: true,
    capabilities: ['client-management', 'relationship-tracking', 'requirement-analysis', 'contract-management'],
    description: 'Manages client relationships, tracks requirements, and handles contract negotiations.',
    category: 'recruiting',
    version: '1.0',
    interfaces: ['a2a-messaging', 'supabase-integration'],
    maxConcurrentTasks: 4,
  },
  {
    id: 'job-matching-agent',
    name: 'Job Matching Agent',
    isAvailable: true,
    capabilities: ['candidate-job-matching', 'compatibility-scoring', 'recommendation-engine', 'market-analysis'],
    description: 'Matches candidates to job opportunities using advanced scoring algorithms.',
    category: 'recruiting',
    version: '1.0',
    interfaces: ['a2a-messaging', 'supabase-integration'],
    maxConcurrentTasks: 6,
  },
  {
    id: 'screening-agent',
    name: 'Screening Agent',
    isAvailable: true,
    capabilities: ['candidate-screening', 'qualification-assessment', 'interview-scheduling', 'reference-checking'],
    description: 'Conducts initial candidate screenings and manages the qualification process.',
    category: 'recruiting',
    version: '1.0',
    interfaces: ['a2a-messaging', 'supabase-integration'],
    maxConcurrentTasks: 4,
  }
];
